// extracted by mini-css-extract-plugin
export default {"customContent":"CustomContent-module__customContent--kB_cu"};